import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/auth";
import { AuthLoadingContainer } from "./ProtectedRoute.styles";
import { Text } from "@hangar/web-components/core/Text";
import { Spinner } from "@hangar/web-components/core/Spinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/login",
}) => {
  const { isAuthenticated, isLoading, isInitialized } = useAuth();
  const location = useLocation();

  if (!isInitialized || isLoading) {
    return (
      <AuthLoadingContainer>
        <Spinner />
        <Text variant="body-lg">Verificando autenticación...</Text>
      </AuthLoadingContainer>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
